import { Dropdown } from 'carbon-components';
import carbonConfig from '../carbon-configs';

class CustomDropdown {
  static init() {
    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    document.addEventListener('dropdown-selected', evt => {
      const selectedId = evt.detail.item.dataset.value;
      const select = evt.target.parentElement.querySelector('select');
      select.options[select.selectedIndex].selected = false;
      select.querySelector(`option[value="${selectedId}"]`).selected = true;
      const event = new CustomEvent('dropdown-custom-selected', {
        bubbles: true,
        cancelable: true,
        detail: {
          item: evt.target.querySelector('.nzr--dropdown--selected')
        }
      });
      evt.target.dispatchEvent(event);
    });

    const dropdownLinks = document.querySelectorAll('.nzr--dropdown-link');

    if (dropdownLinks.length > 0) {
      dropdownLinks.forEach(item => {
        item.addEventListener('keydown', evt => {
          // Enabling select on Enter keydown
          if (event.which === 13) {
            evt.target.click();
          }
        });
      });
    }

    const formDropdowns = document.querySelectorAll(
      'form .nzr--dropdown select.dropdown'
    );

    if (formDropdowns.length > 0) {
      formDropdowns.forEach(item => {
        const dropD = new Dropdown(
          item.parentElement.querySelector('.nzr--dropdown'),
          carbonConfig.dropdown
        );

        if (item.selectedIndex >= 1) {
          dropD.select(
            document.querySelector(
              `.nzr--dropdown-link[data-value="${
                item.options[item.selectedIndex].value
              }"]`
            )
          );
        }
      });
    }
  }
}

export default CustomDropdown;
